// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-navigation-username[data-v-6ae08258]{width:190px!important;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
